import React from 'react';
import { Box, Tooltip } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useNavigate } from 'react-router-dom';

// 수업일·상담일 칸. 누르면 스케줄 화면으로 가서 그 카드에 포커스한다. 링크처럼 보이고, 마우스를 올리면 이동 안내가 뜬다.
// 그룹레슨 = 그룹 스케줄(GroupLesson 의 ?focusClassTimeId=&focusDate=, 카드 ID 가 수업 ID 와 같다),
// 그 외 수업·상담 = 지점 스케줄 일간(PrivateLessonList 의 ?date=&classId= / ?date=&consultationId=).
function ScheduleDateLink({ date, classId, classType, consultationId }) {
  const navigate = useNavigate();
  if (!date || (!classId && !consultationId)) return date || '-';
  const label = '스케줄에서 보기';
  let path;
  if (classId && classType === 'GROUP_LESSON') {
    path = `/group?focusClassTimeId=${classId}&focusDate=${date}`;
  } else if (classId) {
    path = `/private?date=${date}&classId=${classId}`;
  } else {
    path = `/private?date=${date}&consultationId=${consultationId}`;
  }
  return (
    <Tooltip title={label} arrow placement="top">
      <Box
        component="button"
        type="button"
        aria-label={`${date} ${label}`}
        onClick={() => navigate(path)}
        sx={{
          display: 'inline-flex', alignItems: 'center', gap: '3px', p: 0, border: 0, background: 'none',
          font: 'inherit', color: '#262626', cursor: 'pointer',
          textDecoration: 'underline', textDecorationColor: '#C4C4C4', textUnderlineOffset: '3px',
          '& svg': { fontSize: '13px', color: '#A6A6A6', transition: 'color 0.15s, transform 0.15s' },
          '&:hover': { color: '#1565C0', textDecorationColor: '#1565C0' },
          '&:hover svg': { color: '#1565C0', transform: 'translate(1px, -1px)' },
          '&:focus-visible': { outline: '2px solid #1565C0', outlineOffset: '2px', borderRadius: '2px' },
        }}>
        {date}
        <OpenInNewIcon />
      </Box>
    </Tooltip>
  );
}

export default ScheduleDateLink;
